import { useSelector } from 'react-redux'
import { FeaturesType } from '@follow/cdk'
import { useUserEnabledFeature } from '../user'
import { hasAssistantRole, hasDoctorRole } from '../../../misc/roles.utilities'
import { loggedUserSelector } from '../../../store/domain/me/me.selectors'

export const useStatsAssistantEnabled = (): boolean => {
  const statsAssistantEnabled = useUserEnabledFeature(FeaturesType.statsAssistant)
  const loggedUser = useSelector(loggedUserSelector)
  const roles = loggedUser?.roles ?? []

  return (
    Boolean(loggedUser) &&
    Boolean(statsAssistantEnabled) &&
    hasDoctorRole(roles) &&
    !hasAssistantRole(roles)
  )
}
